import { Button, Popconfirm } from '@components'
import { useRequest, useTranslation } from '@hooks'
import { api, message } from '@services'
import { ButtonType, TUser } from '@typings'
import React from 'react'

const RemoveUserLink: React.FC<TProps> = ({ userId, buttonType = 'default', onSuccess }) => {
	const { t } = useTranslation()

	// Remove user.
	const { fetch: removeUser, fetching: removing } = useRequest<void, any>({
		request: () => api.deleteUser(userId),
		onSuccess: () => onSuccess?.(),
		onError: (error) => message.error(error.message),
	})

	return (
		<Popconfirm title={t('Are you sure?')} okText={t('Yes')} cancelText={t('No')} onConfirm={removeUser}>
			<Button loading={removing} danger type={buttonType}>
				{t('Remove')}
			</Button>
		</Popconfirm>
	)
}

type TProps = {
	/** Id of terget user.  */
	userId: TUser['id']
	/** Callback called after successful removing. */
	onSuccess: () => void
	/** Type of button link */
	buttonType?: ButtonType
}

export default RemoveUserLink
